export default __webpack_public_path__ + "static/media/molo-design04.b51345d7.png";